import styled from 'styled-components';

import { colors, layout } from '@prisjakt/ui-base';

export const Empty = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  text-align: center;
  color: ${colors.darkGray2};
  padding: ${layout.spacing.xSmall};
`;

export const EmptyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 2rem;
  margin-top: ${layout.spacing.xSmall};
`;
